var map = {
	"./banner_corvus.png": "c5d6",
	"./banner_corvus@2x.png": "8a69",
	"./banner_delphinus.png": "c0d5",
	"./banner_delphinus@2x.png": "acfd",
	"./banner_leonos.png": "7e00",
	"./banner_leonos@2x.png": "4645a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efdf";